var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_vm._v("Relatórios de Ambulancias")]),_c('v-divider'),_c('v-card-text',[_c('AmbulanceReports')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }